// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"e8ea1895","387":"f7ff25d9","453":"4f451148"}[chunkId] + ".chunk.js";
};